/** @jsx jsx */
import { Flex, Paragraph } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { TimeReportPayCodeAggregate } from "@/data/time-reports";

import { TimeReportCalendarRow } from "./grid/TimeReportCalendarRow";
import { TimeReportCalendarRowHeader } from "./grid/TimeReportCalendarRowHeader";
import { TimeReportCalendarPayCodeRowCell } from "./TimeReportCalendarPayCodeRowCell";

interface TimeReportPayCodeRowProps {
  payCode: TimeReportPayCodeAggregate;
}

export const TimeReportCalendarPayCodeRow: FC<TimeReportPayCodeRowProps> = ({ payCode, ...restProps }) => {
  return (
    <TimeReportCalendarRow {...restProps}>
      <TimeReportCalendarRowHeader>
        <Flex justifyContent="space-between" pl="sm">
          <Paragraph ellipsis>{payCode.name}</Paragraph>
          <Paragraph
            sx={{ display: ["none", null, null, "block"] }}
            color={payCode.loggedTime.isEmpty ? "n500" : "n1000"}>
            {payCode.loggedTime.formattedAmount}
          </Paragraph>
        </Flex>
      </TimeReportCalendarRowHeader>

      {payCode.items.map(item => (
        <TimeReportCalendarPayCodeRowCell key={item.date.toISOString()} item={item} />
      ))}
    </TimeReportCalendarRow>
  );
};
